<template>
  <div @click="onClickTableSearch">
    <AGTooltip :disabled="showTooltip" :tooltip-text="label">
      <v-text-field
        :id="id"
        :ref="id"
        v-model="model"
        class="ag-search-input"
        density="compact"
        variant="solo"
        prepend-icon="mdi-magnify"
        clear-icon="mdi-close"
        clearable
        hide-details
        rounded
        :disabled="isDisabled"
        :label="label"
        :style="styleCustom"
        @blur="onBlur()"
        @focus="onFocus()"
        @click:clear="onClear()"
      />
    </AGTooltip>
  </div>
</template>

<script>
import AgTooltipOld from '@/components/common/AGTooltipOld.vue';
import { debounce, uniqueId } from 'lodash';

export default {
  emits: ['update:modelValue', 'click:clear'],
  components: {
    AGTooltip: AgTooltipOld,
  },

  props: {
    label: {
      type: String,
      required: true,
    },

    id: {
      type: String,
      default: uniqueId('table_search_'),
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    styleCustom: {
      type: String,
      required: false,
    },

    modelValue: {
      type: String,
      default: '',
    },

    delay: {
      type: Number,
      default: 1250,
    },
  },

  data() {
    return {
      inputFocused: false,
    };
  },

  computed: {
    model: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.updateValueDebounced(value);
      },
    },

    updateValueDebounced() {
      return debounce(this.emitInput, this.delay);
    },

    isDisabled() {
      return this.disabled;
    },

    lengthForLabelTest() {
      if (self.innerWidth < 1920) {
        return 60;
      }
      return 93;
    },

    lengthForLabelTestResized() {
      if (self.innerWidth < 1920) {
        return 75;
      }
      return 116;
    },

    showTooltip() {
      return !!(
        (!this.labelResized && this.label?.length <= this.lengthForLabelTest) ||
        (this.labelResized && this.label?.length <= this.lengthForLabelTestResized)
      );
    },

    labelResized() {
      return (![null, undefined].includes(this.model) && this.model.length > 0) || this.inputFocused;
    },
  },

  methods: {
    emitInput(value) {
      this.$emit('update:modelValue', value);
    },

    onClickTableSearch() {
      this.$refs[this.id].focus();
    },

    onClear() {
      this.$emit('click:clear');
    },

    onFocus() {
      this.inputFocused = true;
    },

    onBlur() {
      this.inputFocused = false;
    },
  },
};
</script>
